<template>
  <div v-if="doAuth">
    <auth-frame :key="frameKey" />
  </div>
</template>
<script>
import Visibility from 'visibilityjs'
import AuthService from '@/services/AuthService'
import ErrorLoggingService from '@/services/ErrorLoggingService'
import AuthFrame from './AuthFrame'

export default {
  name: 'Authorize',
  components: {
    AuthFrame
  },
  data () {
    return {
      doAuth: false,
      frameKey: 0
    }
  },
  created: function () {
    var self = this
    Visibility.every(120000, function () {
      self.checkIdToken()
    })
  },
  methods: {
    checkIdToken: function () {
      const self = this
      AuthService.checkIdToken().then(function (res) {
        if (res.data.renewalRequired) {
          self.frameKey += 1
          self.doAuth = true
        } else {
          self.doAuth = false
        }
      }).catch(function (err) {
        ErrorLoggingService.logError(err)
      })
    }
  }
}
</script>
